import React, {Component, PureComponent} from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import {helper, AlertModal, ModalHelper, Dictionary}  from "./../app.js"; 

export default class ShoreTypeSelecter extends PureComponent 
{
    modal = null;

    constructor (props)
    {
        super(props);

        this.state = {
            type: this.props.init_filter.type,
            carrier_type: this.props.init_filter.carrier_type,
            is_unitary: this.props.init_filter.is_unitary,
            alert_message: ''
        };

        this.modal = new ModalHelper(this);

        this.selectType = this.selectType.bind(this);
        this.selectCarrierType = this.selectCarrierType.bind(this);
        this.setUnitary = this.setUnitary.bind(this);
        this.modal.showProjectChangeWarning = this.modal.showProjectChangeWarning.bind(this.modal);
    }
    selectType (e)
    {
        const type = e.target.value,
            filter = helper.copyObject(this.state);

        this.setState({type});

        filter.type = type;
        this.props.on_select(filter, 'shore_filter'); 
    }
    selectCarrierType (e)
    {
        const carrier_type = e.target.value,
            filter = helper.copyObject(this.state);

        this.setState({carrier_type});

        filter.carrier_type = carrier_type;
        this.props.on_select(filter, 'shore_filter');
    }
    setUnitary (e)
    {
        const is_unitary = !e.target.checked,
            filter = helper.copyObject(this.state);

        this.setState({is_unitary});

        filter.is_unitary = is_unitary;
        this.props.on_select(filter, 'shore_filter');
    }
    render () 
    {
        const //trayType = this.props.tray_type,
            trayArticul = this.props.tray_articul,
            carrierTypes = Dictionary.instance.get('carriers'),
            carrierTypesList = Object.keys(carrierTypes).map(type => 
            {
                const typeName = carrierTypes[type];
                type = type.replaceAll('\'', '');
                return <option key={type} value={type}>{typeName}</option>;
            }),
            mountingTypes = Dictionary.instance.get('mounting_types'),
            mountingTypesList = Object.keys(mountingTypes).map(type => 
            {
                const typeName = mountingTypes[type];
                type = type.replaceAll('\'', '');
                return <option key={type} value={type}>{typeName}</option>;
            });
        carrierTypesList.unshift(<option key="none" value="">Выберите несущую поверхность</option>);
        mountingTypesList.unshift(<option key="none" value="">Выберите тип монтажной системы</option>);

        return <><Form.Row>
                    <Form.Group as={Col} md={4}>
                        <Form.Label className={!trayArticul ? 'text-muted' : ''}>Несущая:</Form.Label>
                        <Form.Control onChange={this.selectCarrierType} onClick={this.modal.showProjectChangeWarning} value={this.state.carrier_type} disabled={!trayArticul} as="select" custom>
                            {carrierTypesList}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group as={Col} md={8}>
                        <Form.Label className={!trayArticul ? 'text-muted' : ''}>Тип монтажной системы:</Form.Label>
                        <Form.Control onChange={this.selectType} onClick={this.modal.showProjectChangeWarning} value={this.state.type} disabled={!trayArticul} as="select" custom>
                            {mountingTypesList}
                        </Form.Control>
                    </Form.Group>
                </Form.Row>  
                <Form.Group>
                    <Form.Check onChange={this.setUnitary} onClick={this.modal.showProjectChangeWarning} checked={false === this.state.is_unitary} disabled={!trayArticul} custom label="Подвес сборный?" type="switch" id="is_shore_prefarb_switch" name="" value="true" />
                </Form.Group>
                <AlertModal on_close={() => this.setState({alert_message: ''})} message={this.state.alert_message} /></>;
    }
}
